<script lang="ts" setup></script>

<template>
  <section class="section">
    <div class="section__top">
      <figure class="section__top__bg"
        style="background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('./images/story/service.jpg');">
        <Nimg src="./images/story/service.jpg" class="section__top__bg__img" />
      </figure>
      <div class="section__top__content">
        <div class="section__top__title">service</div>
        <div class="section__top__text">
          從 online 到 offline，24小時不打烊的購物體驗
          <br />
          <br />
          除了從全球選品之外，恆隆行也希望提供最適合每個人的生活好物
        </div>
      </div>
    </div>
    <div class="section__bottom">
      <div class="section__bottom__title">不論是在哪裡，我們希望即時提供適合顧客的生活好物</div>
      <div class="section__bottom__text left">
        線下以超過 70 個 hengstyle 百貨專櫃，並針對不同族群打造特色店面，從營造開放式廚房體驗空間的廚房主題櫃，到針對單身族群打造的「Personal Space 生活場景」DREAM PLAZA專櫃，以及提供父母放心遊逛而打造的親子友善專櫃 LaLaport 等，持續進化，創造出不同的場域體驗。
      </div>
      <div class="section__bottom__text right">
        線上成立 hengstyle 線上購物，隨時提供最新情境主題及選品指南，提供便利生活解決方案。不僅在線下立體化生活的種種可能的美好樣貌，線上也可以透過 Line 與 APP
        隨時隨地掌握最新優惠與選品指南，選購最合適自己的產品。
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.section {
  margin-left: toRem(-24);
  margin-right: toRem(-24);
  background-color: $color-white-1;

  &__top {
    position: relative;

    &__bg {
      margin-left: toRem(-24);
      margin-right: toRem(-24);
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-attachment: fixed;

      @include max-media(1280) {
        position: absolute;
        left: 0;
        top: 0;
        width: calc(100% + toRem(48));
        height: 100%;
      }

      @include max-media(430) {
        background-attachment: unset;
      }

      img {
        width: 100%;
        opacity: 0;
      }
    }

    &__content {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      padding-left: toRem(24);
      padding-right: toRem(24);
      @include grid;
      align-items: center;
      color: $color-white-1;

      @include max-media(1280) {
        @include grid(4, 24);
        position: relative;
        padding-top: toRem(280);
        padding-bottom: toRem(280);
        height: auto;
      }
    }

    &__title {
      grid-column: 3 / span 4;
      margin-top: toRem(-150);
      font-size: toRem(158);
      font-family: $font-TextaAlt;
      font-weight: 500;
      line-height: 0.8;

      @include max-media(1280) {
        font-size: toRem(80);
        grid-column: 1 / span 4;
      }
    }

    &__text {
      grid-column: 8 / span 3;
      padding-top: toRem(400);
      font-size: toRem(22);
      font-weight: 500;
      line-height: 1.3;

      @include max-media(1280) {
        grid-column: 1 / span 4;
        padding-top: toRem(32);
        font-size: toRem(20);
        line-height: toRem(28);
      }
    }
  }

  &__bottom {
    position: relative;
    z-index: 1;
    padding-top: toRem(90);
    padding-bottom: toRem(180);
    padding-left: toRem(24);
    padding-right: toRem(24);
    @include grid;

    @include max-media(640) {
      @include grid(4, 24);
      padding-top: toRem(75);
      padding-bottom: toRem(75);
    }

    &__title {
      grid-column: 5 / span 4;
      margin-bottom: toRem(55);
      font-size: toRem(22);
      font-weight: 500;
      line-height: 1.3;
      color: $color-brand-3;
      text-align: center;

      @include max-media(1280) {
        grid-column: 2 / span 10;
      }

      @include max-media(640) {
        grid-column: 1 / span 4;
        font-size: toRem(20);
        margin-bottom: toRem(24);
      }
    }

    &__text {
      font-size: toRem(16);
      line-height: 1.45;
      letter-spacing: 0.4px;

      &.left {
        grid-column: 3 / span 4;

        @include max-media(1280) {
          grid-column: 2 / span 5;
        }

        @include max-media(640) {
          grid-column: 1 / span 4;
          margin-bottom: toRem(24);
        }
      }

      &.right {
        grid-column: 7 / span 4;

        @include max-media(1280) {
          grid-column: 7 / span 5;
        }

        @include max-media(640) {
          grid-column: 1 / span 4;
        }
      }
    }
  }
}
</style>
